var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97687 26.1871C10.5669 19.4349 13.2489 13.2728 17.3715 8.35241C17.9845 7.62431 17.9309 6.55131 17.2566 5.88452L12.7891 1.41628C12.0382 0.665181 10.7968 0.703502 10.0995 1.50058C9.4558 2.24401 8.83511 3.01044 8.24507 3.79985C7.44047 4.88051 6.68185 5.99949 5.97687 7.15679C4.9194 8.89657 3.9922 10.713 3.1876 12.6061C2.6512 13.863 2.18377 15.1582 1.76998 16.4765C0.950053 19.113 0.383004 21.8645 0.0918158 24.6926C0.0535017 25.0911 0.0151875 25.4973 -0.00780102 25.9035C-0.0767665 26.9612 0.773808 27.8502 1.83128 27.8502H8.14546C9.08798 27.8502 9.88492 27.1298 9.96921 26.1871H9.97687Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.c4257d4aaa3db83957d6274c341ad13f.svg";
export { ForwardRef as ReactComponent };